import { UnitsAndCaloriesPerDay } from "@dcc/types/drinkingDay";
import { DayOfWeek } from "@dcc/types/dayOfWeek";
import { SLIDER_CALORIES_PER_UNIT } from "@dcc/constants/drinkConstants";
import { roundToNDecimalPlaces } from "@dcc/common/rounding";

export const getCaloriesFromUnitsForEachDay = (
  units: number
): UnitsAndCaloriesPerDay[] => {
  return [
    {
      day: DayOfWeek.Monday,
      units,
      calories: roundToNDecimalPlaces(units * SLIDER_CALORIES_PER_UNIT, 2)
    }
  ];
};
